import React, { useContext } from "react";
import { TiDelete } from "react-icons/ti";
import { AppContext } from "../context/AppContext";

const ExpenseItem = (props) => {
  const { dispatch, newCurrency } = useContext(AppContext);

  const handleDeleteExpense = () => {
    dispatch({
      type: "DELETE_EXPENSE",
      payload: props.id,
    });
  };

  const increaseAllocation = (name) => {
    const expense = {
      name: name,
      cost: 10,
    };

    dispatch({
      type: "ADD_EXPENSE",
      payload: expense,
    });
  };

  const decreaseAllocation = (name) => {
    const expense = {
      name: name,
      cost: 10,
    };

    dispatch({
      type: "DEC_EXPENSE",
      payload: expense,
    });
  };

  return (
    <>
      <tr>
        <td>{props.name}</td>
        <td>
          {newCurrency}
          {props.cost}
        </td>

        <td>
          <button
            className="btn btn-success me-md-5 justify-content-md-end"
            onClick={(event) => increaseAllocation(props.name)}
          >
            +
          </button>
          <button
            className="btn btn-dark justify-content-md-end"
            onClick={(event) => decreaseAllocation(props.name)}
          >
            -
          </button>
        </td>

        <td className="btn btn-danger d-grid gap-2 d-md-block">
          <TiDelete size="1.5em" onClick={handleDeleteExpense}>
            x
          </TiDelete>
        </td>
      </tr>
    </>
  );
};

export default ExpenseItem;
